import type { FC } from "react";

import { Icon } from "../../Icon";
import { Flex } from "../../Flex";
import { Text } from "../../Text";

import { stepChipStyle } from "./StepChip.css";
import type { OCRProgressStep } from "../OCRUploadCard";

export type StepChipProps = {
  /**
   * Status of the processing step
   */
  status: OCRProgressStep["status"];
  /**
   * Label to display
   */
  label: string;
};

/**
 * Renders a status indicator for an OCR processing step
 */
export const StepChip: FC<StepChipProps> = ({ status, label }) => {
  const IconComponent = () => {
    switch (status) {
      case "completed":
        return <Icon icon="check" size="s" />;
      case "error":
        return <Icon icon="close" size="s" />;
      case "pending":
        return <Icon icon="waiting" size="s" />;
      default:
        return <Icon icon="loading" size="s" animation="rotation" />;
    }
  };

  return (
    <Flex className={stepChipStyle({ status })} gap="xxs" align="center">
      <IconComponent />
      <Text variant="bodyS" noWrap>
        {label}
      </Text>
    </Flex>
  );
};

StepChip.displayName = "StepChip";
